import { useEffect, useState } from 'react';
import { useIFrameSrc } from '../../../../shared/public/SlCodeEditorComponents/utils/hooks';

export const useIframeHeight = () => {
	const [iframeHeight, setIframeHeight] = useState<number>(0);

	const iframeSrc = useIFrameSrc();

	useEffect(() => {
		const receiveIframeMessage = (e) => {
			if (e.origin !== iframeSrc) {
				return;
			}
			const iframeHeight = e.data?.iframeHeight;

			if (iframeHeight) {
				setIframeHeight(iframeHeight + 20);
			} else if (iframeHeight === 0) {
				setIframeHeight(iframeHeight);
			}
		};

		window.addEventListener('message', receiveIframeMessage, false);

		return () => {
			window.removeEventListener(
				'message',
				receiveIframeMessage,
				false,
			);
		};
	}, []);

	return iframeHeight;
};
